<!--/*
* @name: 点巡检记录
* @description: 点巡检记录
* @author: zefeng(zefeng.chen@shengyc.com)
* @Date: 2019-09-09 08:18:02
* @LastEditTime: 2019-09-09 08:18:02
*/
-->
<template>
  <div id="maintenance-list-container">
    <nav-header headTitle="点巡检记录" bg="#0152b4" color="#ffffff">
      <a
        href="javascript:;"
        class="nav-btn_left"
        slot="head_left"
        @click="$router.back()"
      />
    </nav-header>
    <div id="main">
      <div class="searchBox">
        <div class="searchMain">
          <div class="searchIconBox">
            <div class="searchIcon"></div>
          </div>
          <form id="search_from" @submit.prevent="submitFrom">
            <input
              v-model="q_name"
              class="searchInput"
              type="search"
              placeholder="搜索"
            />
          </form>
        </div>
      </div>
      <div v-show="Sloading" id="EquInspectionHistory_SLoading" />
      <div v-if="!Sloading" class="list-container">
        <van-list
          v-show="InspectionListInfo.length != 0"
          class="list-wrapper"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          loading-text="加载中..."
          @load="$_onLoad"
        >
          <div
            class="item-card"
            v-for="(InspectionItem, maintenanceIndex) in InspectionListInfo"
            :key="maintenanceIndex"
            @click="$_clickItem(InspectionItem)"
          >
            <report-card :cardData="InspectionItem" />
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { get_inspection_records } from '@/service/getData';
import ReportCard from '@/components/common/ReportCard/ReportCard';
import NavHeader from '@/components/NavHeader/NavHeader.vue';
import { pathOr } from '@/config/Utils';
import moment from 'moment';
export default {
  name: 'EquInspectionHistoryListScreen',
  components: { ReportCard, NavHeader },
  data() {
    return {
      Sloading: '',
      pageNum: 1,
      q_name: '',
      loading: false,
      finished: false,
      pathOr: pathOr,
      isShowSearch: false,
      InspectionListInfo: [],
      GY: [
        {
          label: '设备名称',
          code: 'entity_name',
          content: ''
        },
        {
          label: '巡检人',
          code: 'operator_name',
          content: ''
        },
        {
          label: '计划开始时间',
          code: 'expected_started_time',
          content: ''
        },
        {
          label: '计划过期时间',
          code: 'expected_expired_time',
          content: ''
        }
      ]
    };
  },
  mounted() {
    this.$_init();
  },
  methods: {
    $_goBack() {
      this.$router.back();
    },
    submitFrom() {
      this.$_onRefresh();
    },
    $_clodeSearch() {
      this.pageNum = 1;
      this.q_name = '';
      this.isShowSearch = false;
      this.$_init();
    },
    $_onLoad() {
      setTimeout(() => {
        this.pageNum += 1;
        this.$_init();
      }, 1000);
    },
    $_onRefresh() {
      this.pageNum = 1;
      this.$_init();
    },
    /**
     * 没有更多数据
     */
    $_noMoreData() {
      this.finished = true;
    },
    /**
     * 停止加载
     */
    $_stopLoading() {
      this.loading = false;
    },
    $_ShowSearch() {
      this.isShowSearch = !this.isShowSearch;
    },
    //加载中
    $_loading() {
      this.Sloading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgb(242, 242, 242)',
        target: document.querySelector('#EquInspectionHistory_SLoading')
      });
    },
    $_init() {
      // document.getElementById('search_from').onsubmit = () => {
      //   this.$_onRefresh();
      //   return false;
      // };
      if (this.pageNum == 1) {
        this.$_loading();
      }
      get_inspection_records({
        token: localStorage.getItem(location.host + 'token'),
        page_num: this.pageNum,
        q_name: this.q_name,
        status: 2
      }).then(res => {
        if (res) {
          if (this.Sloading) {
            setTimeout(() => {
              this.Sloading.close();
              this.Sloading = '';
            }, 1000);
          }
          this.$_stopLoading();
          res.result &&
            res.result.map(val => {
              let temp = this.GY.map(valG => {
                if (
                  valG.code == 'expected_started_time' ||
                  valG.code == 'expected_expired_time'
                ) {
                  if (val[valG.code] > 0) {
                    return Object.assign({}, valG, {
                      content: moment(pathOr('', [valG.code], val)).format(
                        'YYYY-MM-DD HH:mm:ss'
                      )
                    });
                  } else {
                    return Object.assign({}, valG, {
                      content: pathOr('', [valG.code], val)
                    });
                  }
                } else {
                  return Object.assign({}, valG, {
                    content: pathOr('', [valG.code], val)
                  });
                }
              });
              return Object.assign(val, {
                GY: temp
              });
            });
          if (this.pageNum == 1) {
            this.InspectionListInfo = res.result;
          } else {
            if (res.result.length == 0) {
              this.$_noMoreData();
            } else {
              this.InspectionListInfo = this.InspectionListInfo.concat(
                res.result
              );
            }
          }
        }
      });
    },
    /**
     * 点击卡片事件
     */
    $_clickItem(InspectionItem) {
      this.$router.push({
        path: '/equInspectionHistoryeHistory_detail',
        query: {
          id: pathOr('', ['id'], InspectionItem)
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/style/mixin';
.el-loading-spinner {
  i {
    font-size: vw(30);
  }
}
</style>

<style lang="scss">
@import '../../assets/style/mixin';

#EquInspectionHistory_SLoading {
  height: calc(100% - 25vw);
}
#maintenance-list-container {
  -webkit-overflow-scrolling: touch; //实现苹果手机的滚动回弹效果
  @include wh(100vw, 100vh);
  display: flex;
  flex-direction: column;
  .nav-btn_left {
    display: block;
    @include wh(vw(44), vw(44));
    background: transparent url('../../assets/images/left_arrow.png') no-repeat
      center center;
    background-size: vw(10), vw(18);
  }
  .nav-btn_right {
    display: block;
    height: vw(44);
    line-height: vw(44);
    font-size: vw(14);
    color: #ffffff;
  }
  #headerMenuBox {
    background: #0152b4;
    .head_left {
      display: block;
      @include wh(vw(44), vw(44));
      background: transparent url('../../assets/images/left_arrow.png')
        no-repeat center center;
      background-size: vw(10), vw(18);
    }
    .head_right {
      display: block;
      background-color: transparent;
      @include wh(vw(44), vw(44));
      @include fja(center, center);
    }
    .head_center {
      position: relative;
      .searchInput {
        background-color: transparent;
      }
      .searchIconBox {
        @include wh(vw(30), vw(30));
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: vw(8);
        .searchIcon {
          @include wh(vw(20), vw(20));
          background: transparent url('../../assets/images/search_button.png')
            no-repeat center center;
          background-size: vw(20), vw(20);
        }
      }

      .cube-input::after {
        border: none;
      }
      .cube-input_active::after {
        border: none;
      }
      .searchInput {
        @include wh(2vw (60), vw(30));
        border-radius: vw(15);
        background-color: #256cc3;
        padding-left: vw(40);
        font-size: vw(14);
        color: #9fceff;
      }
      // .searchInput::-webkit-input-placeholder {
      //   color: #9fceff;
      //   font-size: vw(14);
      //   // opacity: 0.5;
      // }
    }
    .head_right > span {
      color: #9fceff;
      font-size: vw(14);
    }
  }
  #main {
    .searchBox {
      background: #ffffff;
      padding: vw(10) vw(16);
      .searchMain {
        flex-direction: row;
        display: flex;
        align-items: center;
        background: #e4eff4;
        padding: vw(10) vw(12);
      }
      .searchIconBox {
        border-right: 1px solid #999999;
        margin-right: vw(12);
        padding-right: vw(12);
        .searchIcon {
          @include wh(vw(20), vw(20));
          background: transparent url('../../assets/images/search_button.png')
            no-repeat center center;
          background-size: vw(20), vw(20);
        }
      }
      #search_from {
        flex: 1;
      }
      .searchInput {
        @include wh(100%, vw(30));
        border-radius: vw(15);
        font-size: vw(14);
        line-height: vw(15);
        color: #333333;
      }
      // .searchInput::-webkit-input-placeholder {
      //   color: #999999;
      //   line-height: vw(14);
      //   font-size: vw(14);
      //   // opacity: 0.5;
      // }
    }
    // height: calc(100vh - 11.733333vmin);
    flex: 1;
    overflow: auto;
    padding-bottom: vw(8);
    .list-container {
      padding-top: vw(8);
      .list-wrapper {
      }
    }
  }
}
</style>
